import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import LandscapeBaseAddTemplate from '../../../templates/LandscapeBaseAddTemplate';
import LandscapeAboutBaseAddTemplate from '../../../templates/LandscapeAboutBaseAddTemplate';
import { NotSavedInfoMolecule } from '../../molecules';

interface LandscapeAboutNotSavedInfoTemplateProps {
  content: string;
}

const LandscapeAboutNotSavedInfoTemplate: FC<
  LandscapeAboutNotSavedInfoTemplateProps
> = ({ content }) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseAddTemplate>
          <LandscapeAboutBaseAddTemplate>
            <NotSavedInfoMolecule content={content} />
          </LandscapeAboutBaseAddTemplate>
        </LandscapeBaseAddTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeAboutNotSavedInfoTemplate;
